import { resetPassword } from "../../actions/manageUsersActions";
import { useState } from "react";
import { connect } from "react-redux";
import ArrowGoBack from "../../components/ArrowGoBack/ArrowGoBack";
import styles from "./index.module.css";
import alert from "../../components/AlertModal/alertModal";
import confirm from "../../components/ConfirmModal/confirm";
import InputText from "../../components/InputText";
import Button from "../../components/Button";

const RegisterForm = (props) => {
  const { resetPassword } = props;
  const { firstname, lastname, email, username, role } = props.userData;

  const [state, setState] = useState({
    password: "",
    repeatPassword: "",
  });

  const mediaQuery = window.matchMedia("(max-width: 427px)");
  const roleName = role ? role.charAt(0).toUpperCase() + role.slice(1) : "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !state.password ||
      !state.repeatPassword ||
      state.repeatPassword !== state.password ||
      state.password.length < 8
    ) {
      return;
    }
    try {
      const confirmFun = await confirm(
        "CONFIRM",
        "Are you sure you want to update your password?",
      );
      if (!confirmFun) return;

      await resetPassword(props.userData.idUser, state.password);
      alert("SUCCESS", "Password updated successfully");
      setState({ password: "", repeatPassword: "" });
    } catch (error) {
      alert("ERROR", error);
    }
  };

  const handleChangePass = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value.trim(),
    });
  };

  const validateForm = () => {
    return (
      <div className={styles.validationContainer}>
        {state.repeatPassword !== state.password && (
          <div className={styles.errorMessage}>
            The password and confirm password do not match.
          </div>
        )}
        {state.password && state.password.length < 8 && (
          <div className={styles.errorMessage}>
            Password must be at least 8 characters long.
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={`box-container ${styles.principalDis}`}>
      <ArrowGoBack />

      {/* Encabezado con Nombre y Rol */}
      <div className={styles.chartBlue}>
        {!mediaQuery.matches && (
          <div className={styles.headerText}>
            <div className={styles.name}>
              {firstname} {lastname}
            </div>
            <div className={styles.rolename}>{roleName}</div>
          </div>
        )}
      </div>

      <div className={styles.boxDown}>
        <form className={styles.form}>
          {mediaQuery.matches && (
            <div className={styles.nameCon}>
              <div className={styles.name}>
                {firstname} {lastname}
              </div>
              <div className={styles.rolename}>{roleName}</div>
            </div>
          )}

          <div className={styles.firstspace}>
            <div className={styles.keyVal}>
              <div className={styles.subtitle}>USERNAME: </div>
              <div className={styles.definition}> {username} </div>
            </div>
            <div className={styles.keyVal}>
              <div className={styles.subtitle}>MAIL: </div>
              <div className={styles.definition}> {email} </div>
            </div>
          </div>

          <div className={styles.passwordSpace}>
            <div className={styles.inputGroup}>
              <InputText
                type="password"
                name="password"
                placeholder={"New Password"}
                value={state.password}
                onChange={handleChangePass}
              />
            </div>
            <div className={styles.inputGroup}>
              <InputText
                type="password"
                name="repeatPassword"
                value={state.repeatPassword}
                placeholder={"Confirm password"}
                onChange={handleChangePass}
              />
            </div>
          </div>
          {validateForm()}
        </form>

        <div className={styles.downBox}>
          {/* Solo el botón de Save, centrado o alineado a la derecha según prefieras */}
          <div className={styles.saveContainer}>
            <Button
              size="medium"
              label="SAVE CHANGES"
              styleButton="main"
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.usersReducer.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (idUser, password) =>
    dispatch(resetPassword(idUser, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm);
